import axios from 'axios';
import {AesTools} from '../tool/AesTools'
function Server(){
}
Server.prototype={
    constructor:Server,
    model:null,
    aesTools:new AesTools(),
    init:function(){
        
    },
    updateColor:function(model){
        axios.post("./model/update", model).then((res) => {
            if (res.data != "error") {
            //   $message.success("已成功修改模型");
              this.list();
              this.upload.show = false;
            } else {
              this.$message.error("模型修改失败，请重试或联系管理员！");
            }
          });
    },
    getSenssionAuthor:function(password,username,callBack){
      let questData={"password":password,"username":username};
      axios.post("http://47.114.80.9:8000/api/v1/user/login",questData).then((data)=>{
        if(data.statusText==="OK"){
          callBack({"msg":"success",data:data.data});
        }else{
          return callBack({"msg":"error"});
        }
      })
    },
    getSenssionInfo:function(msg){
      console.log(msg);
      axios.post("./mqttServer/hotPoint").then((data)=>{
        if(data.statusText==="OK"){
          console.log(data)
        }else{
          return console.log("msg","error");
        }
      })
    },
    getSenssionHistory:function(authorization,callBack){
      let questData={"authorization":"bearer "+authorization};
      axios.get("http://47.114.80.9:8000/api/v1/history/ffffff1000014775/2/0/1",questData).then((data)=>{
        if(data.statusText==="OK"){
          callBack({"msg":"success",data:data.data});
        }else{
          return callBack({"msg":"error"});
        }
      })
    },
    //modelList相关：
    userInfo:function(userID,password,callBack){
      var user={"id":userID,"password":password};
      axios.post("./user/userInfo", user).then((data)=>{
        callBack(data.data);
      })
    },
//获取模型类型
    getModelType:function(callBack) {
      let modelType=[];
      axios.post("./model/getModelType").then((res) => {
        modelType = res.data || [];
        callBack(modelType);
      });
    },
//根据id获取模型
    getModel:function(id,callBack){
      axios.post("./model/getModel", id).then((res) => {
          this.model = res.data || {};
          callBack({model:this.model,data:{id:id}});
        });
  },
  //根据材质名称获取所有贴图
  getMaps:function(name,callBack){
    axios.post("./model/getMaps",name).then((res)=>{
      callBack(res);
    })
  },
    //根据名字模糊搜索模型
    list:function(search,callBack) {
      var models=[];
      axios.post("./model/list", search).then((res) => {
        models = res.data || [];
        callBack(models);
      });
    },
     //根据用户ID获取模型
     modelByUser:function(userID,callBack){
      var models=[];
      var param=this.aesTools.Encrypt(userID);
      console.log(param );
      axios.post("./model/modelByUser",  {"userID":param}).then((res) => {
        models = res.data || [];
        callBack(models);
      });
  },
    //获取所有公开的模型列表
    modelPublic:function(callBack){
      var models=[];
      axios.post("./model/modelPublic").then((res) => {
        models = res.data || [];
        callBack(models);
      });
    },
     //获取所有非本人的公开的模型列表
     modelNotMineAndPublic:function(userID,callBack){
      var models=[];
      var param=this.aesTools.Encrypt(userID);
      console.log(param);
      axios.post("./model/modelNotMineAndPublic",  {"userID":param}).then((res) => {
        models = res.data || [];
        callBack(models);
      });
  },
  //验证文件是否存在
  isFileExits:function(path,callBack){
    var isExits=false;
    axios.post("./Utils/isFileExits",  {"path":path}).then((res) => {
      callBack(res);
      // isExits = res.data || [];
      // callBack(models);
    });
},
}
export{
    Server
}